/* 🤖 this file was generated by svg-to-ts */
export const matIconPriorityHigh: {
  name: 'priority-high';
  data: string;
} = {
  name: 'priority-high',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><circle cx="12" cy="19" r="2"/><path d="M10 3h4v12h-4z"/></svg>`
};
